import React from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import truncate from "lodash/truncate";
import {
  CreateOrUpdateTransactionParams,
  useCreateCashTransaction,
} from "@bn/api/apiv1";
import { PageLayout } from "@components";
import { useAccounts } from "@api/v1/hooks/useAccounts";
import { convertDateToOnlyDateString } from "@helpers/date/dateFormat";
import { AddManuallyPageForm } from "./components/AddManuallyPageForm";

export const AddManuallyPage = () => {
  const { t } = useTranslation();
  const { accountId } = useParams<"accountId">();
  const parsedAccountId = Number.parseInt(accountId!, 10);
  const { data: accountsResponse, isFetching: isAccountsLoading } = useAccounts(
    {
      id: [parsedAccountId],
    }
  );
  const {
    mutateAsync: saveCashTransaction,
    isPending: isSavingLoading,
    error,
    reset,
    status,
  } = useCreateCashTransaction();

  const [account] = accountsResponse?.accounts ?? [];

  const handleSubmit = (values: CreateOrUpdateTransactionParams) => {
    saveCashTransaction({
      createOrUpdateTransactionParams: {
        ...values,
        valueDate: convertDateToOnlyDateString(values.valueDate),
        accountId: parsedAccountId,
      },
    });
  };
  const requestStatus =
    status === "success" || status === "error" ? status : undefined;

  return (
    <PageLayout
      title={t("addManuallyPage.header.title")}
      subtitle={t("addManuallyPage.header.subtitle")}
      isFetching={isAccountsLoading}
      breadcrumbs={[
        { to: "/", text: t("breadcrumbs.home") },
        {
          to: "/depots-accounts",
          text: t("breadcrumbs.depotsAccounts"),
        },
        {
          to: `/accounts/${accountId}`,
          text: truncate(account?.name),
        },
        {
          text: t("addManuallyPage.addManuallyBreadcrumb"),
        },
      ]}
    >
      <AddManuallyPageForm
        isAccountsLoading={isAccountsLoading}
        isSavingLoading={isSavingLoading}
        requestStatus={requestStatus}
        errorMessage={error?.response?.data?.message}
        onReset={() => reset()}
        onSubmit={handleSubmit}
      />
    </PageLayout>
  );
};
